// The gold rosette used in the certifications strip. Drawn as SVG rather than
// shipped as an image so it stays crisp at any size and needs no asset.

const CENTER = 50;
const SPIKES = 32;
const OUTER_R = 48;
const INNER_R = 43;

// Alternating outer/inner radii around the circle give the scalloped edge.
const rosettePoints = Array.from({ length: SPIKES * 2 }, (_, i) => {
  const radius = i % 2 === 0 ? OUTER_R : INNER_R;
  const angle = (Math.PI * i) / SPIKES - Math.PI / 2;
  return `${(CENTER + radius * Math.cos(angle)).toFixed(2)},${(
    CENTER +
    radius * Math.sin(angle)
  ).toFixed(2)}`;
}).join(" ");

// 72px rather than the original 96: small enough that the seal stops
// out-shouting the rest of the footer, large enough that the standard number
// inside it stays legible — below about 70px that text turns to mush.
const CertSeal = ({ label, size = 72 }) => {
  // Gradient ids must be unique per instance or the first one wins for all.
  const gradientId = `seal-gold-${label.replace(/\W+/g, "-")}`;

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role="img"
      aria-label={`${label} certified`}
      className="shrink-0"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f6e27a" />
          <stop offset="45%" stopColor="#d9b44a" />
          <stop offset="100%" stopColor="#b8860b" />
        </linearGradient>
      </defs>

      <polygon points={rosettePoints} fill={`url(#${gradientId})`} />
      <circle cx={CENTER} cy={CENTER} r="39" fill="#f7ecc6" />
      <circle
        cx={CENTER}
        cy={CENTER}
        r="35"
        fill="none"
        stroke="#b8860b"
        strokeWidth="1.5"
      />
      <text
        x={CENTER}
        y={CENTER}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="12"
        fontWeight="700"
        letterSpacing="0.4"
        fill="#8b2f24"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
      >
        {label}
      </text>
    </svg>
  );
};

export default CertSeal;
